import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { WalletProvider } from "./contexts/WalletContext.js";
import { WagmiProvider } from 'wagmi'
import { QueryClientProvider } from '@tanstack/react-query'
import { wagmiConfig, queryClient } from './config/appkit.js'
import Header from "./Components/Header/Header.jsx";
import Latest_nft from "./Components/Latest_nft/Latest_nft.jsx";
import Partners from "./Components/Partners/Partners.jsx";
import Landing_page from "./Components/Landing_page/Landing_page.jsx";
import Footer from "./Components/Footer/Footer.jsx";
import FAQ from "./Components/FAQ/FAQ.jsx";
import Get_started from "./Components/Get_started/Get_started.jsx";
import HowMint from "./Components/HowMint/HowMint.jsx";

function App() {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <WalletProvider>
          <div className="App">
            <Header/>
            <Landing_page/>
            <Partners/>
            <Get_started/>
            <Latest_nft/>
            <HowMint/>
            <FAQ/>
            <Footer/>
          </div>
        </WalletProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
